import { BoldSpan } from './Configuration.styles';

export const FlipFlop = ({
  flipFlop,
  first,
  second
}: {
  flipFlop: boolean;
  first: string;
  second: string;
}) => {
  return flipFlop ? (
    <>
      <BoldSpan>{first}</BoldSpan>&nbsp;→ {second}
    </>
  ) : (
    <>
      {first} ←&nbsp;<BoldSpan>{second}</BoldSpan>
    </>
  );
};
